import { render, staticRenderFns } from "./UserAlias.vue?vue&type=template&id=43d99b16&"
import script from "./UserAlias.vue?vue&type=script&lang=js&"
export * from "./UserAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports